import { render, staticRenderFns } from "./AddNoteCredit.vue?vue&type=template&id=ffdc4252&"
import script from "./AddNoteCredit.vue?vue&type=script&lang=js&"
export * from "./AddNoteCredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports